<template>
  <div style="width: 100%; text-align:left;">
    <Container v-if="currentView === 'Container'" :IsShowCursomColumns="true" :columns="columns" :filedID="filedID" ref="templateTag" @openSearch="openSearch" @LuneceSearch="LuneceSearch" @getAllTask="getAllTask" @deleteResult="deleteResult" :templateTitle="templateTitle" :bigTemplateTitle="bigTemplateTitle" :isBlank="true" :isViewType="false" :category="6" :isBrowseRecords="false" :IsExpandShow="true" :styelHeight="100" :styelTableHeight="110" :isShowHeader="isShowHeader" :Type="type">
      <!-- <template v-slot:button>
        <el-button @click="btnAddContact" size="mini" type="primary">新增联系人</el-button>
        <el-button @click="editContact" size="mini" type="primary">修改联系人</el-button>
        <el-button @click="delContact" size="mini" type="primary">删除联系人</el-button>
      </template> -->
      <template v-slot:button>
        <div class="user-btn-groups " style="text-align: left;">
          <el-button @click="btnAddOrEditUser('add')" class="more_thanfour_btn" type="primary" icon="el-icon-plus">新增人员</el-button>
          <el-button @click="btnAddOrEditUser('edit')" class="more_thanfour_btn" type="primary" icon="el-icon-edit">编辑人员</el-button>
          <el-button @click="changePassword" class="more_thanfour_btn" type="primary" icon="el-icon-edit-outline">重置密码</el-button>
          <el-button @click="handleDownload" class="more_thanfour_btn" type="primary" icon="el-icon-tickets">导出人员</el-button>
        </div>
      </template>
      <template v-slot:CursomColumns>
        <el-button icon="el-icon-s-unfold" size="mini" type="primary" @click="filterColumns" class="less_thanfour_icon margin-lg-8"></el-button>
      </template>
      <template v-slot:main="slotProps">
        <el-card class="boxcard">
          <el-table v-loading="loading" ref="multipleTable" :data="allData" highlight-current-row :header-cell-style="{'font-family':'MicrosoftYaHei','font-weight':'bold','font-size':'16px','padding': '5px 0','background':'#f8f6f6','color':'#333333','letter-spacing': '0.6px'}" :cell-style="{'font-family':'MicrosoftYaHei','font-size':'16px','padding': '5px 0','color':'#4f5869'}" style="width: 100%" @select="select" @select-all="selectAll" @row-contextmenu="rowContextmenu" @current-change="currentChanged" border>
            <el-table-column type="selection" width="50" v-if="isCheckbox"></el-table-column>
            <template v-for="item in tableColumns">
              <el-table-column :key="item.prop" :label="item.label" :min-width="item.minWidth">
                <template slot-scope="scope">
                  <template v-if="item.label === '姓名'">
                    <ChatUser style="float: left;margin-right:2px" :userInfo="{id:scope.row.ID,name:scope.row.SysUserName}"></ChatUser>
                  </template>
                  <template v-else-if="item.label === '类型'">
                    <el-tag :type="scope.row.IsLogin === 0 ? 'info' : 'success'" effect="dark">{{ scope.row.IsLogin === 0 ? '联系人' : '人员' }}</el-tag>
                  </template>
                  <template v-else-if="item.label === '人员状态'">
                    <el-tag :type="scope.row.SysUserState === 0 ? 'danger' : 'success'" effect="dark">{{ scope.row.SysUserState === 0 ? '禁用' : '启用' }}</el-tag>
                  </template>
                  <template v-else-if="item.label === '是否锁定'">
                    <el-tag :type="scope.row.IsLock === 0 ? 'success' : 'info'" effect="dark">{{ scope.row.IsLock === 0 ? '否' : '是' }}</el-tag>
                  </template>
                  <template v-else-if="item.label === '登录状态'">
                    <el-tag :type="scope.row.IsLogin === 0 ? 'info' : 'success'" effect="dark">{{ scope.row.IsLogin === 0 ? '不可登录' : '可登录' }}</el-tag>
                  </template>
                  <template v-else-if="item.label === '微信绑定'">
                    <el-tag effect="dark" :type="scope.row.OpenId?'success':'danger'">{{scope.row.OpenId ? '是' : '否'}}</el-tag>
                  </template>
                  <template v-else>
                    {{scope.row[item.prop]}}
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <Pagination v-if="paginationVisible" :total="total" :page-sizes="[10,20,30,40]" :page="pageParams.Pageindex" :limit="pageParams.Pagesize" @changelist="handlePaginationChange"></Pagination>
          <!-- <el-pagination v-if="paginationVisible" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageParams.Pageindex" :page-sizes="[10, 20, 30, 40]" :page-size="pageParams.Pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
        </el-card>
        <el-row>
          <el-col :span="24">
            <span style="background: white;">
              <el-tag v-if="showSercParams.Keyword">关键字:{{showSercParams.Keyword}}</el-tag>
              <el-tag v-if="showSercParams.CompanyName">机构组织:{{showSercParams.CompanyName}}</el-tag>
              <el-tag v-if="showSercParams.DeptName">岗位:{{showSercParams.DeptName}}</el-tag>
              <el-tag v-if="showSercParams.SearchRange==0">搜索范围:全部</el-tag>
              <el-tag v-if="showSercParams.SearchRange==1">搜索范围:人员</el-tag>
              <el-tag v-if="showSercParams.SearchRange==2">搜索范围:联系人</el-tag>
              <el-tag v-if="showSercParams.SearchRange==3">搜索范围:微信注册</el-tag>
              <el-tag v-if="showSercParams.SearchRange==4">搜索范围:人员和微信注册</el-tag>
              <el-tag v-if="showSercParams.SearchRange==4">搜索范围:联系人和微信注册</el-tag>
              <el-tag v-if="showSercParams.SearchRange==6">搜索范围:人员和联系人</el-tag>
            </span>
          </el-col>
        </el-row>
      </template>
    </Container>
    <userSearchDialog ref="userSearchDialog" @search="getSearchResult" @searchDialogClosed="searchDialogClosed" @getTotal="getTotal" @getSearParm="getSearParm" @pageviseable="pageviseable" :IsContainContact="true"></userSearchDialog>
    <AddContact ref="addContact" @successSubmit="successSubmit"></AddContact>

    <v-contextmenu ref="contextmenus">
      <v-contextmenu-item @click="handelChat">发起会话</v-contextmenu-item>
    </v-contextmenu>

    <AddOrEditFormView ref="AddOrEditFormView" v-if="currentView === 'AddOrEditFormView'" :contentConfig="contentConfig" :operate="operate" @selectChange="selectChange" @inputChange="inputChange">
      <!-- 附件 -->
      <template v-slot:fileUpload="data">
        <div class="item-wrap-title">
          <anybao-uploader ref="uploader" :file-status-text="fileConfig.fileStatusText" :PathId="fileConfig.PathId" :baseAddress="fileConfig.baseAddress" :currentUser="fileConfig.currentUser" :savePath="fileConfig.savePath" @file-removed="data.slotData.fileRemoved" @file-success="data.slotData.fileSuccess">
            <div>
              {{ data.slotData.title }}
              <anybao-uploader-btn>
                    上传附件
              </anybao-uploader-btn>
            </div>
            <anybao-uploader-unsupport></anybao-uploader-unsupport>
            <anybao-uploader-list></anybao-uploader-list>
          </anybao-uploader>
        </div>
      </template>
      <!-- 头像 -->
      <template v-slot:userPicture>
        <div class="item-wrap-pic">
          <anybao-uploader ref="picUploader" :baseAddress="baseAddress" :currentUser="currentUser" :single="true" :savePath="savePath" :PathId="PathId" :file-status-text="fileStatusText" @file-success="fileSuccess" @file-complete="fileComplete">
            <anybao-uploader-unsupport></anybao-uploader-unsupport>
            <!-- <anybao-uploader-drop> -->
            <anybao-uploader-btn>
              <div class="user-picture-wrap">
                <img :src="src" alt="">
              </div>
            </anybao-uploader-btn>
            <!-- </anybao-uploader-drop> -->
            <!-- <anybao-uploader-list></anybao-uploader-list> -->
          </anybao-uploader>
        </div>
      </template>
      <!-- 联系信息 -->
      <template v-slot:cursomContactInfo>
        <el-form ref="contactForm" :rules="ContactRules" :model="ContactInfoForm" label-position="left" class="item-form" :inline="false" label-width="180px" size="small">
          <el-row :gutter="120" class="contact-el-row" v-for="(item, index) in ContactInfoItem" :key="index">
            <el-col :span="18">
              <el-form-item v-for="(columns, i) in item.count" :key="i" class="contact-info-item" :prop="item.prop + '_' + i" :class="{'contact-info-item-validate': i === 0}">
                <template slot="label">
                  <div class="contact-info-item-label-wrap">
                    <i :class="[item.icon, 'contact-info-item-icon']"></i>
                    <el-select v-if="item.selectLabel" v-model="ContactInfoForm[item.selectProp + '_' + i]" class="contact-info-item-select-wrap">
                      <el-option v-for="v in item.selectOptions" :key="v.value" :label="v.lable" :value="v.value" />
                    </el-select>
                    <span v-else style="padding-left: 15px;">{{item.label}}</span>
                  </div>
                </template>
                <el-input v-model="ContactInfoForm[item.prop + '_' + i]" :disabled="item.disabled ? item.disabled : false"></el-input>
                <span class="contact-info-item-btns">
                  <el-button icon="el-icon-plus" circle size="mini" :disabled="item.prop === 'ContactDateInfoList' || (item.prop ==='ContactPhoneInfoList' && item.count >=3)" type="primary" @click="AddSameContactProp(item)"></el-button>
                  <!-- 每种类型可添加多个，多个可删除，每种仅剩1条不可删除 -->
                  <el-button icon="el-icon-close" circle size="mini" type="primary" @click="DeleteSameContactProp(item, i)" :disabled="item.count === 1 && i === 0"></el-button>
                </span>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </template>
    </AddOrEditFormView>
    <columnsDialog :columnsDialogConfig="columnsDialogConfig" :tableColumns="tableColumns" @handleCheckBox="handleCheckBox"></columnsDialog>

    <!-- 修改密码 -->
    <updatePwd :updateDialogVisable="updateDialogVisable" @closeDiaPwd="closeDiaPwd" @closelogm="closelogm"></updatePwd>
  </div>
</template>

<script>
import updatePwd from "@/views/task/common/login/updatePwd.vue";

import columnsDialog from "@/views/resource/components/common/columnsDialog.vue" // 表格动态列操作
import Pagination from "@/components/Pagination" // 
import AddOrEditFormView from "@/components/AddOrEditFormView";
import Container from "@/components/MainLayout/Container.vue";
import userSearchDialog from "@/components/basicTemplate/userSearchDialog.vue";
import ChatUser from "@/views/task/Chat/ChatUser.vue";
import AddContact from "@/components/basicTemplate/SelectUser/AddContact.vue";
import Sortable from "sortablejs";
import { mapState } from "vuex";

import { DeleteContactInfoById } from "@/api/modules/basicData/baseTemplateInterface";

import {
  // GetAllCustomerVWInfo,
  // GetListDeptByCompanyExId,
  // GetTemplateUserSearchResult,
  // GetTemplateUserSearchResultByTemplateID,
  GetNewEmergencyUserSearchResultCountByTemplateId,
  // GetTemplateUserSearchResultCount,
  GetNewEmergencyUserSearchResultCount
} from "@/api/modules/basicData/organization";


import { GetDictInfoListByType } from '@/api/modules/resources/administrationOrgan.js'

//用户信息
import { getToken } from "@/util/auth";
import { getUserJobList, getSortRange, upDateUserInfo } from "@/api/modules/resources/userRun"
import { VerifyUserCodeAndPhone } from "@/api/modules/resources/organManage"
import { vxRule } from '@/utils/el-validate'
import { deepClone } from "@/util/userUtil"

export default {
  name: "UserMange",
  components: {
    Container,
    userSearchDialog,
    ChatUser,
    AddContact,
    AddOrEditFormView,
    columnsDialog,
    Pagination,
    updatePwd
  },
  data() {
    const _this = this
    return {
      updateDialogVisable:false, 
      TEMPID: null,
      TEMPTYPE: 0,
      pageParams: {
        Pageindex: 1, 
        Pagesize: 10,
      },
      total: 0, //总条数
      paginationVisible: false, //分页控件默认隐藏,
      columnsDialogConfig: {
        visible: false,
        form: {
          mustColumns: ['SysUserName', 'SysUserCode', 'DutyName', 'IsLoginName', 'SysUserSex', 'Telphone', 'EmergencyCompanyofDeptList', 'EmergencyPostInfoList', 'SysUserState', 'OpenId'],
          optionalColumns: []
        },
        formList: [
          {
            label: "必选列",
            prop: "mustColumns",
            disabled: true,
            list: [
              {
                label: '姓名',
                prop: 'SysUserName',
                disabled: true
              },
              {
                label: '工号',
                prop: 'SysUserCode',
                disabled: true
              },
              {
                label: '职务',
                prop: 'DutyName',
                disabled: true
              },
              {
                label: '类型',
                prop: 'IsLoginName',
                disabled: true
              },
              {
                label: '性别',
                prop: 'SysUserSex',
                disabled: true
              },
              {
                label: '手机号',
                prop: 'Telphone',
                disabled: true
              },
              {
                label: '所属机构组织',
                prop: 'EmergencyCompanyofDeptList',
                disabled: true
              },
              {
                label: '所在岗位',
                prop: 'EmergencyPostInfoList',
                disabled: true
              },
              {
                label: '人员状态',
                prop: 'SysUserState',
                disabled: true
              },
              {
                label: '审核状态',
                prop: '',
                disabled: true
              },
              {
                label: '微信绑定',
                prop: 'OpenId',
                disabled: true
              }
            ]
          },
          {
            label: "可选列",
            prop: "optionalColumns",
            list: [
              {
                label: '年龄',
                prop: 'Age'
              },
              {
                label: '职位',
                prop: 'Position'
              },
              {
                label: '是否锁定',
                prop: 'IsLock'
              },
              {
                label: '登录状态',
                prop: 'IsLoginState'
              },
              {
                label: '人员级别',
                prop: 'Grade'
              },
              {
                label: '职称',
                prop: 'JobTitle'
              },
              {
                label: '邮箱',
                prop: 'Email'
              }
            ]
          }
        ]
      },
      tableColumns: [
        {
          label: '姓名',
          prop: 'SysUserName',
          minWidth: 170
        },
        {
          label: '工号',
          prop: 'SysUserCode',
          minWidth: 120
        },
        {
          label: '职务',
          prop: 'DutyName',
          minWidth: 130
        },
        {
          label: '类型',
          prop: 'IsLoginName',
          minWidth: 100
        },
        {
          label: '性别',
          prop: 'SysUserSex',
          minWidth: 80
        },
        {
          label: '手机号',
          prop: 'Telphone',
          minWidth: 150
        },
        {
          label: '所属机构组织',
          prop: 'EmergencyCompanyofDeptList',
          minWidth: 180
        },
        {
          label: '所在岗位',
          prop: 'EmergencyPostInfoList',
          minWidth: 180
        },
        {
          label: '人员状态',
          prop: 'SysUserState',
          minWidth: 120
        },
        {
          label: '审核状态',
          prop: '',
          minWidth: 120
        },
        {
          label: '微信绑定',
          prop: 'OpenId',
          minWidth: 120
        },



        // {
        //   label: '年龄',
        //   prop: 'Age',
        //   minWidth: 80
        // },
        // {
        //   label: '职位',
        //   prop: 'Position',
        //   minWidth: 80
        // },
        // {
        //   label: '是否锁定',
        //   prop: 'IsLock',
        //   minWidth: 100
        // },
        // {
        //   label: '登录状态',
        //   prop: 'IsLoginState',
        //   minWidth: 100
        // },
        // {
        //   label: '人员级别',
        //   prop: 'Grade',
        //   minWidth: 100
        // },
        // {
        //   label: '职称',
        //   prop: 'JobTitle',
        //   minWidth: 120
        // },
        // {
        //   label: '邮箱',
        //   prop: 'Email',
        //   minWidth: 180
        // }
      ],
      file_0_List: [],
      file_1_List: [],
      fileConfig: {
        fileStatusText: {
          success: "上传成功",
          error: "上传失败",
          uploading: "上传中",
          paused: "MD5加密",
          waiting: "等待中"
        },
        PathId: "0",
        baseAddress: "http://117.71.55.7:14909",
        currentUser: {
          userId: getToken().userId, //用户id
          userName: getToken().realName //用户名称
        },
        savePath: ""
      },
      src: require('@/assets/默认头像.png'),
      fileStatusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "MD5加密",
        waiting: "等待中"
      },
      PathId: "0",
      savePath:'',
      // rootId: '',
      baseAddress: 'http://117.71.55.7:14909',
      currentUser: {
        userId: getToken().userId,
        userName: getToken().realName
      },
      EmergencyPostInfoList: [],
      EmergencyCompanyofDeptList: [],
      ContactRules: {
        ContactPhoneInfoList_0: vxRule(true, null, "blur", "至少输入一个号码信息"),
      },
      ContactInfoForm: {
        phoneSelect_0: '登录号码',
        ContactDateInfoList_0: ''
      },
      ContactInfoItem: [
        {
          count: 1,
          prop: 'ContactPhoneInfoList',
          selectLabel: true,
          icon: 'el-icon-phone-outline',
          selectProp: 'phoneSelect',
          selectOptions: [
            {
              lable: '登录号码',
              value: '登录号码'
            },
            {
              lable: '对外显示号码',
              value: '对外显示号码'
            },
            {
              lable: '短信接收号码',
              value: '短信接收号码'
            }
          ]
        },
        {
          count: 1,
          prop: 'ContactEmailInfoList',
          label: '个人邮箱',
          icon: 'el-icon-message',
        },
        {
          count: 1,
          prop: 'ContactImInfoList',
          label: 'QQ',
          icon: 'el-icon-chat-line-round',
        },
        {
          count: 1,
          prop: 'ContactDateInfoList',
          label: '生日',
          disabled: true,
          icon: 'el-icon-user',
        },
        {
          count: 1,
          prop: 'ContactUrlInfoList',
          label: '公司网址',
          icon: 'el-icon-location-information',
        },
        {
          count: 1,
          prop: 'ContactAddressInfoList',
          label: '单位',
          icon: 'el-icon-house',
        },
      ],
      contentConfig: [
        {
          name: 'userPicture'
        },
        {
          title: '基础信息',
          form: {},
          labelWidth: '130px',
          rules: {
            SysUserCode: vxRule(true, async function(v) {
              if(!v) return { result: false,  errMsg: '工号不能为空' }
              let params = {
                code: v,
                id: '',
                telephone: ''
              }
              if(_this.currentSelectedRow) {
                params.id = _this.currentSelectedRow.ID
              }
              const regex = /^[a-zA-Z0-9]{1,9}$/
              if(regex.test(v)) {
                const { result, errMsg } = await _this.VerifyUserCodeAndPhone(params)
                return { result, errMsg }
              } else {
                return { result: false,  errMsg: '只能输入1~9个数字、字母' }
              }}, 
            "blur", "只能输入1~9个数字、字母"),
            SysUserName: vxRule(true, null, "blur", "姓名不能为空"),
            IdNumber: vxRule(true, 'idNumber', "blur", "身份证信息不能为空"),
            SysUserSex: vxRule(true, null, "change", "性别不能为空"),
            SysUserState: vxRule(true, null, "change", "人员状态不能为空"),
            IsLock: vxRule(true, null, "change", "是否锁定不能为空"),
            IsLogin: vxRule(true, null, "change", "登录状态不能为空"),
          },
          formItemList: [
            {
              xl: 8,
              lg: 8,
              md: 12,
              prop: 'SysUserCode',
              type: 'input',
              
              label: '工号',
              placeholder: '请输入工号'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'SysUserName',
              label: '姓名',
              placeholder: '请输入姓名'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'IdNumber',
              label: '身份证号',
              placeholder: '请输入身份证号'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '性别',
              prop: 'SysUserSex',
              type: 'radio',
              methods: () => {},
              list: [
                {
                  label: '男',
                  value: 1
                },
                {
                  label: '女',
                  value: 2
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '人员状态',
              type: 'radio',
              prop: 'SysUserState',
              methods: () => {},
              list: [
                {
                  label: '启用',
                  value: 1
                },
                {
                  label: '禁用',
                  value: 0
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '是否锁定',
              prop: 'IsLock',
              type: 'radio',
              methods: () => {},
              list: [
                {
                  label: '未锁定',
                  value: 0
                },
                {
                  label: '锁定',
                  value: 1
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '登录状态',
              prop: 'IsLogin',
              type: 'radio',
              methods: () => {},
              list: [
                {
                  label: '可登录',
                  value: 1
                },
                {
                  label: '不可登录',
                  value: 0
                }
              ]
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              prop: 'Grade',
              label: '人员级别',
              type: 'rate'
            },
          ]
        },
        {
          title: '职业信息',
          form: {},
          labelWidth: '130px',
          rules: {
            EmergencyCompanyofDeptList: vxRule(true, null, "change", "所属组织不能为空"),
            EmergencyPostInfoList: vxRule(true, null, "change", "所属岗位不能为空"),
            DutyId: vxRule(true, null, "change", "所属职务不能为空"),
          },
          formItemList: [
            {
              multiple: true,
              type: 'organization',
              prop: 'EmergencyCompanyofDeptList',
              isSelCompany: false, // 机构不可选 只能选组织
              label: '所属组织(可多选)',
              placeholder: '请输入所属组织',
              getValue: (val) => {
                this.EmergencyCompanyofDeptList = []
                val.length && val.forEach(v => {
                  this.EmergencyCompanyofDeptList.push({
                    CompanyId: v.CompanyId,
                    CompanyName: v.CompanyName,
                    DeptName: v.DeptName,
                    DeptId: v.DeptId,

                  })
                })
              }
            },
            {
              multiple: true,
              type: 'post',
              prop: 'EmergencyPostInfoList',
              label: '所属岗位(可多选)',
              placeholder: '请输入所属岗位',
              getValue: (val) => {
                this.EmergencyPostInfoList = []
                val.length && val.forEach(v => {
                  this.EmergencyPostInfoList.push({
                   PostId: v.ID,
                   PostName: v.Name
                  })
                })
              }
            },
            {
              multiple: true,
              type: 'select',
              prop: 'DutyId',
              list: [],
              label: '所属职务(可多选)',
              placeholder: '请输入职务'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'input',
              prop: 'Position',
              label: '职位',
              placeholder: '请输入职位'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'date',
              prop: 'EntryTime',
              label: '入职日期',
              placeholder: '请输入入职日期'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              type: 'date',
              prop: 'ResignationTime',
              label: '离职日期',
              placeholder: '请输入离职日期'
            },
          ]
        },
        {
          title: '特定执业信息（根据实际选填）',
          form: {},
          labelWidth: '130px',
          formItemList: [
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'CivilDutyId',
              label: '公务员职务',
              list: []
            },
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'yishizhicheng',
              label: '医师职称',
              list: []
            },
            {
              type: 'select',
              xl: 8,
              lg:8,
              md:12,
              prop: 'hushijibie',
              label: '护士级别',
              list: []
            },
            {
              type: "cascader",
              label: "执业类别和范围",
              prop: "PracticeTypeId",
              placeholder: "选择执业类别和范围",
              props: {
                lazy: true,
                label: "NAME",
                value: "ID",
                leaf: "leaf",
                lazyLoad(node, resolve) {
                  const { level } = node;
                  let ParentId = "0";
                  if (level !== 0) {
                    ParentId = node.value;
                  }
                  getSortRange({ ParentId }).then(res => {
                    const arr = res.map(v => {
                      v.leaf = level >= 1;
                      return v;
                    });
                    resolve(res);
                  });
                }
              }
            },
            {
              type: 'onlyOrg',
              prop: 'PracticeOrgId',
              label: '执业地点',
              getValue: val => {
                console.log(val, '这是执业地点')
              }
            },
          ]
        },
        {
          title: '教育信息',
          form: {},
          labelWidth: '130px',
          formItemList: [
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '毕业院校',
              prop: 'School',
              type: 'input',
              placeholder: '请输入毕业院校'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '学历',
              prop: 'EducationId',
              type: 'select',
              list: [],
              placeholder: '请输入学历'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '学位',
              prop: 'DegreeId',
              type: 'select',
              list: [],
              placeholder: '请输入学位'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '专业',
              prop: 'Profession',
              type: 'input',
              placeholder: '请输入专业'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '入学时间',
              prop: 'ReadingStartTime',
              type: 'date',
              placeholder: '请输入入学时间'
            },
            {
              xl: 8,
              lg: 8,
              md: 12,
              label: '毕业时间',
              prop: 'ReadingEndTime',
              type: 'date',
              placeholder: '请输入毕业时间'
            },
          ]
        },
        {
          title: '联系信息',
          name: 'cursomContactInfo'
        },
        {
          title: '附件',
          cursomTitle: true,
          name: 'fileUpload',
          fileSuccess: (a, b, c, d) => {
            if(c.id){
              this.file_0_List.push({
                FilePath: '',
                Name: c.filename,
                HasCode: c.hashcode,
                FileType: 0,
                FileId: c.id,
                Url: c.url
              })
            }
            console.log('这是上传成功后的回调')
            console.log(this.file_0_List)
          },
          fileRemoved: (a) => {
            const fileId = a.id || a[0].id
            const index = this.file_0_List.findIndex((item, i) => {
              return fileId === item.Id || fileId === item.FileId
            })
            console.log(index, '这是iindex_____________')
            if(index !== -1) this.file_0_List.splice(index,1)
          }
        }
      ],
      operate: [
        {
          loadingBtn: false,
          icon: 'el-icon-circle-check',
          type: 'primary',
          name: '提交',
          handleClick: () => {
            this.handleSubmit()
          }
        },
        {
          loadingBtn: false,
          // icon: 'el-icon-check',
          type: 'default',
          name: '取消',
          handleClick: () => {
            this.currentView = 'Container'
          }
        }
      ],
      currentView: 'Container',
      contextmenuRow: {},
      loading: false,
      filedID: "Key",
      templateTitle: "人员面板管理",
      bigTemplateTitle: "联系人",
      columns: [
        {
          text: "姓名",
          value: "Name",
        },
      ],
      allData: [],
      currentSelectedRow: null,
      type: parseInt(this.$route.query.type || 0),
      rows: this.$route.query.rows,
      queryParams: {
        OpUserId: getToken().userId,
        Para: `{"CurrentUserId": ${getToken().userId}, "Keyword": "", "ListCompanyDept": [], "ListPostId": [], "SearchRange":0}`
      },
      showSercParams: {
        //保存搜索参数
        Keyword: "",
        CompanyName: "",
        DeptName: "",
        SearchRange: null,
      },
    };
  },
  props: {
    isShowHeader: {
      type: Boolean,
      default: false,
    },
  },
  created() {
      console.log('this.currentView==>', this.currentView)
  },
  methods: {
    VerifyUserCodeAndPhone(params) {
      return new Promise((resolve, reject) => {
        VerifyUserCodeAndPhone(params).then(res => {
          // res.Success === false重复    res.Success === true不重复
          let obj = {
            result: res.Success,
            errMsg: res.Result
          }
          resolve(obj)
          return
        })
      })
    },
    pageviseable(val) {
      this.paginationVisible = val;
    },
    getSearParm(parm) {
      let params = JSON.parse(parm);
      for (let key in params) {
        if (key == "Keyword" && params[key] != "") {
          this.showSercParams.Keyword = params[key];
        }

        if (key == "ListCompanyDept" && params[key].length > 0) {
          params[key].forEach((query) => {
            for (let val in query) {
              if (val == "CompanyName" && query[val]) {
                this.showSercParams.CompanyName = query[val];
              }
              if (val == "DeptName" && query[val]) {
                this.showSercParams.DeptName = query[val];
              }
            }
          });
        }

        if (key == "SearchRange") {
          this.showSercParams.SearchRange = params[key];
          console.log(this.showSercParams.SearchRange);
        }
      }
      this.queryParams.Para = parm;
    },
    getTotal(count) {
      this.total = count;
    },
    handlePaginationChange({ current, size }) {
      const page = current
      if(size === this.pageParams.pagesize) {
        page = 1
      }
      this.pageParams = {
        Pageindex: page,
        Pagesize: size   
      }
      if(this.TEMPTYPE === 0) {
        this.GetTemplateUserSearchResultCount()
      }else {
        this.GetTemplateUserSearchResultByTemplateID(this.TEMPID, this.userId)
      }
    },
    resetForm() {
      this.contentConfig.forEach((v, i) => {
        if(v.form) v.form = {} // 置空form表单
        if(i === 1) v.form = { Grade: 3, SysId : '' } // 默认等级为三级, SysId新增时为空
        this.ContactInfoForm = { phoneSelect_0: '登录号码' } // 联系信息初始化
      })
      this.ContactInfoItem.forEach(v => { v.count = 1 })
      this.file_1_List = []
      this.file_0_List = []
    },
    // 新增、编辑
    btnAddOrEditUser(type) {
      this.currentView = 'AddOrEditFormView'
      this.resetForm()
      if(type === 'edit') {
        if (this.currentSelectedRow) {
        //   this.currentView = 'AddOrEditFormView'
          const data = this.currentSelectedRow
          this.$nextTick(() => {
            data.SysAttachFileList && data.SysAttachFileList.length && data.SysAttachFileList.forEach(file => {
              // fileType 0为附件 1为头像
              if(file.FileType === 0) {
                // 回显附件信息
                this.$refs.uploader.defaultList.push({
                  id: file.Id,
                  isFolder: false,
                  isRoot: false,
                  name: file.Name,
                  paused: false,
                  relativePath: file.Name
                })
                // 赋值附件信息
                this.file_0_List.push({
                  FilePath: '',
                  Name: file.Name,
                  HasCode: file.HasCode,
                  FileType: 0,
                  FileId: file.FileId,
                  Id: file.Id,
                  Url: file.Url
                })
              }
              if(file.FileType === 1) {
                const item  = {
                  baseAddress:'http://117.71.55.7:14909',
                  FileId: file.FileId,
                  fileName: file.Name,
                  CreateUserId: this.userId,
                  CreateUserName: this.realName
                }
                // 回显src
                this.src = this.matchTypeImg(item)
                // 赋值头像信息
                this.file_1_List.push({
                  FilePath: '',
                  Name: file.Name,
                  HasCode: file.HasCode,
                  FileType: 1,
                  Id: file.Id,
                  FileId: file.FileId,
                  Url: file.Url
                })
              }
            })
          })
          if(data.Sysuser) {
            this.$set(this.contentConfig[1], 'form', data.Sysuser)
            this.$set(this.contentConfig[2].form, 'Position', data.Sysuser.Position)
            this.$set(this.contentConfig[2].form, 'EntryTime', data.Sysuser.EntryTime)
            this.$set(this.contentConfig[2].form, 'ResignationTime', data.Sysuser.ResignationTime)
            // this.contentConfig[1].form = data.Sysuser
            // this.contentConfig[2].form.Position = data.Sysuser.Position
            // this.contentConfig[2].form.EntryTime = data.Sysuser.EntryTime
            // this.contentConfig[2].form.ResignationTime = data.Sysuser.ResignationTime
            const DutyId = data.Sysuser.DutyId.split(',').map(v => {return v - 0})
            // this.contentConfig[2].form.DutyId = data.Sysuser.DutyId.split(',').map(v => {return v - 0})
            this.$set(this.contentConfig[2].form, 'DutyId', DutyId)
            this.$set(this.contentConfig[3].form, 'CivilDutyId', data.Sysuser.CivilDutyId) // 公务员职务
            // this.contentConfig[3].form.CivilDutyId = data.Sysuser.CivilDutyId 
          }
          if(data.Emergencyaddtioninfo) {
            this.$set(this.contentConfig[1].form, 'Grade', data.Emergencyaddtioninfo.Grade)
            // this.contentConfig[1].form.Grade = data.Emergencyaddtioninfo.Grade
            const DeptList = data.Emergencyaddtioninfo.EmergencyCompanyofDeptList && data.Emergencyaddtioninfo.EmergencyCompanyofDeptList.map(v => {
              return '2_' + v.DeptId
            })
            const PostInfoList = data.Emergencyaddtioninfo.EmergencyPostInfoList && data.Emergencyaddtioninfo.EmergencyPostInfoList.map(v => {
              return v.PostId
            })
            this.$set(this.contentConfig[2].form, 'EmergencyCompanyofDeptList', DeptList)
            this.$set(this.contentConfig[2].form, 'EmergencyPostInfoList', PostInfoList)
            // this.contentConfig[2].form.EmergencyCompanyofDeptList = data.Emergencyaddtioninfo.EmergencyCompanyofDeptList && data.Emergencyaddtioninfo.EmergencyCompanyofDeptList.map(v => {
            //   return '2_' + v.DeptId
            // })
            // this.contentConfig[2].form.EmergencyPostInfoList = data.Emergencyaddtioninfo.EmergencyPostInfoList && data.Emergencyaddtioninfo.EmergencyPostInfoList.map(v => {
            //   return v.PostId
            // })
            // 回显联系信息
            this.ContactInfoItem.forEach(v => {
              const prop = v.prop
              switch (prop) {
                case 'ContactAddressInfoList': // 地址
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.Address)
                    // this.ContactInfoForm[prop + '_' + i] = k.Address
                  })
                  break
                case 'ContactDateInfoList': // 生日
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.SpecialDate)
                    // this.ContactInfoForm[prop + '_' + i] = k.SpecialDate
                  })
                  break
                case 'ContactEmailInfoList': // 邮箱
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.Email)
                    // this.ContactInfoForm[prop + '_' + i] = k.Email
                  })
                  break
                case 'ContactPhoneInfoList': // 号码
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.Phone)
                    this.$set(this.ContactInfoForm, 'phoneSelect_' + i, k.PhoneType)
                    // this.ContactInfoForm[prop + '_' + i] = k.Phone
                    // this.ContactInfoForm['phoneSelect_' + i] = k.PhoneType
                  })
                  break
                case 'ContactImInfoList': // qq
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.Im)
                    // this.ContactInfoForm[prop + '_' + i] = k.Im
                  })
                  break
                case 'ContactUrlInfoList': // 网址
                  data.Emergencyaddtioninfo[prop].forEach((k, i) => {
                    this.$set(this.ContactInfoForm, prop + '_' + i, k.Url)
                    // this.ContactInfoForm[prop + '_' + i] = k.Url
                  })
                  break
              }
              if(data.Emergencyaddtioninfo[prop].length){
                v.count = data.Emergencyaddtioninfo[prop].length
              }
            })
          }
          if(data.SysUserPracticeinfo) {
            const PracticeOrgId  = data.SysUserPracticeinfo.PracticeOrgId && data.SysUserPracticeinfo.PracticeOrgId.split(',')
            this.$set(this.contentConfig[3].form, 'PracticeOrgId', PracticeOrgId) // 执业地点
            // this.contentConfig[3].form.PracticeOrgId = data.SysUserPracticeinfo.PracticeOrgId && data.SysUserPracticeinfo.PracticeOrgId.split(',')  // 执业地点
            if(data.SysUserPracticeinfo.ParentPracticeTypeId && data.SysUserPracticeinfo.PracticeTypeId) {
              this.$set(this.contentConfig[3].form, 'PracticeTypeId', [data.SysUserPracticeinfo.ParentPracticeTypeId, data.SysUserPracticeinfo.PracticeTypeId]) // 职业类别和范围
              // this.contentConfig[3].form.PracticeTypeId = [data.SysUserPracticeinfo.ParentPracticeTypeId, data.SysUserPracticeinfo.PracticeTypeId] // 职业类别和范围
            }
            if(data.SysUserPracticeinfo.JobTitleId) {
              const JobTitleId = data.SysUserPracticeinfo.JobTitleId
              if(JobTitleId[0] === 'B') { // B开头为医生, C开头为护士
                // this.contentConfig[3].form.yishizhicheng = JobTitleId
                this.$set(this.contentConfig[3].form, 'yishizhicheng', JobTitleId)
              }else {
                // this.contentConfig[3].form.hushijibie = JobTitleId
                this.$set(this.contentConfig[3].form, 'hushijibie', JobTitleId)
              }
            }
          }
          if(data.SysUserEducationalinfo) this.contentConfig[4].form = data.SysUserEducationalinfo
        } else {
          this.$message({
            message: "请先点击待编辑的数据行！",
            type: "warning",
          });
          return;
        }
      } else {
        // 新增时置空
        this.currentSelectedRow = null
      }
      // 字典表信息
      this.initDict(
        {prop: 'CivilDutyId', parm: 'gwyzc'}, // 公务员职称
        {prop: 'EducationId', parm: 'xlxx'}, // 学历
        {prop: 'DegreeId', parm: 'xwxx'}, // 学位
        {prop: 'hushijibie', parm: 'hszc'}, // 护士级别
        {prop: 'yishizhicheng', parm: 'yszc'} // 医师职称
      )
      // 职务表
      this.getUserJobList()
    },
    // 重置密码
    changePassword() {
      if(this.currentSelectedRow) {
        this.updateDialogVisable = true
      } else {
        this.$message({
          message: "请先点击待修改的数据行！",
          type: "warning",
        })
        return
      }
    },
    closeDiaPwd(val) {
      this.updateDialogVisable = val
    },
    closelogm(val) {
      console.log(val)
      this.updateDialogVisable = val
    },
    initDict() {
      const arg = [].slice.call(arguments)
      for(let i=0; i< arg.length; i++) {
        // 公务员职称
        this.GetDictInfoListByType(arg[i].parm).then(res => {
          // CivilDutyId
          this.setDictSelectOptions(arg[i].prop, res)
          
        })
      }
    },
    setDictSelectOptions(prop, data) {
      this.contentConfig.forEach(v => {
        v.formItemList && v.formItemList.forEach(k => {
          if(k.prop === prop) {
            k.list = data.map(v => {
              const obj = {
                value: v.CODE,
                label: v.NAME
              }
              return obj
            })
            return 
          }
        })
      })
    },
    selectChange(item) {
      const prop = item.prop
      switch (prop) {
        case 'yishizhicheng':
          if(this.contentConfig[3].form['hushijibie']) { 
            delete this.contentConfig[3].form['hushijibie']
            this.contentConfig[3].form['JobTitleId'] = this.contentConfig[3].form['yishizhicheng']
          }
          break
        case 'hushijibie':
          if(this.contentConfig[3].form['yishizhicheng']) { 
            delete this.contentConfig[3].form['yishizhicheng']
            this.contentConfig[3].form['JobTitleId'] = this.contentConfig[3].form['hushijibie']
          }
          break
      }
    },
    inputChange(item) {
      if(item.prop === 'IdNumber') {
        const BirthDay = this.contentConfig[1].form.IdNumber.slice(6, 14)
        const bArr = BirthDay.split('')
        bArr.splice(4, 0, '-')
        bArr.splice(7, 0, '-')
        this.$set(this.ContactInfoForm, 'ContactDateInfoList_0', )
        this.ContactInfoForm['ContactDateInfoList_0'] = bArr.join('')
        console.log(this.ContactInfoForm)
      }
    },
    initForm() {
      this.EmergencyPostInfoList = []
      this.EmergencyCompanyofDeptList = []
      this.contentConfig.forEach(v => {
        // v.form && v.form = {}
      })
    },
    filterColumns() {
      this.columnsDialogConfig.visible = true
    },
    // 表格动态列操作
    handleCheckBox(columns) {
      this.tableColumns = columns
    },
    // 提交
    async handleSubmit() {
      // 基础信息
      const Sysuser = deepClone(this.contentConfig[1].form) // 人员级别需要放到辅助信息里面去
      Sysuser.CreateUserId = this.userId
      // 职业信息
      const PostInfo = deepClone(this.contentConfig[2].form) // 职务 职位 入职 离职放到基础信息里面去
      Sysuser.DutyId = PostInfo.DutyId && PostInfo.DutyId.join(',')
      Sysuser.Position = PostInfo.Position
      Sysuser.EntryTime = PostInfo.EntryTime
      Sysuser.ResignationTime = PostInfo.ResignationTime
      // 教育信息
      const SysUserEducationalinfo  = deepClone(this.contentConfig[4].form)
      // 特定执业信息
      const SysUserPracticeinfo = deepClone(this.contentConfig[3].form) // 公务员放到基础信息里面去
      Sysuser.CivilDutyId = SysUserPracticeinfo.CivilDutyId
      SysUserPracticeinfo.PracticeOrgId = SysUserPracticeinfo.PracticeOrgId && SysUserPracticeinfo.PracticeOrgId.join(',') // 执业地点
      SysUserPracticeinfo.PracticeTypeId = SysUserPracticeinfo.PracticeTypeId && SysUserPracticeinfo.PracticeTypeId[SysUserPracticeinfo.PracticeTypeId.length - 1] // 执业类型和范围子节点
      SysUserPracticeinfo.ParentPracticeTypeId = SysUserPracticeinfo.PracticeTypeId && SysUserPracticeinfo.PracticeTypeId[0] // 执业类型和范围 父节点
      SysUserPracticeinfo.JobTitleId = SysUserPracticeinfo.yishizhicheng || SysUserPracticeinfo.hushijibie // 职称
      // 文件
      const SysAttachFileList = [].concat(this.file_0_List, this.file_1_List)
      // delete Sysuser.Grade
      
      const ContactPhoneInfoList = [] // 电话
      const ContactEmailInfoList = [] // 邮箱
      const ContactImInfoList = [] // qq
      const ContactDateInfoList = [] // 生日
      const ContactUrlInfoList = [] // 网址
      const ContactAddressInfoList = [] // 地址
      for (const key in this.ContactInfoForm) {
        if(key.indexOf('ContactPhoneInfoList') !== -1) {
          const index = key.split('_')[1]
          ContactPhoneInfoList.push({
            PhoneType: this.ContactInfoForm['phoneSelect_' + index],
            Phone: this.ContactInfoForm[key]
          })
        }
        if(key.indexOf('ContactEmailInfoList') !== -1) ContactEmailInfoList.push({Email: this.ContactInfoForm[key], EmailType: '个人邮箱'})
        if(key.indexOf('ContactImInfoList') !== -1) ContactImInfoList.push({ImType: 'QQ', Im: this.ContactInfoForm[key]})
        if(key.indexOf('ContactDateInfoList') !== -1) ContactDateInfoList.push({DateType: '生日', SpecialDate: this.ContactInfoForm[key]})
        if(key.indexOf('ContactUrlInfoList') !== -1) ContactUrlInfoList.push({UrlType: '公司网址', Url: this.ContactInfoForm[key]})
        if(key.indexOf('ContactAddressInfoList') !== -1) ContactAddressInfoList.push({AddressType: '单位', Address: this.ContactInfoForm[key]})
      }
      // 辅助信息
      const Emergencyaddtioninfo = {
        Grade: Sysuser.Grade,
        EmergencyPostInfoList: this.EmergencyPostInfoList, // 岗位
        EmergencyCompanyofDeptList: this.EmergencyCompanyofDeptList, // 机构组织
        ContactPhoneInfoList, // 电话
        ContactEmailInfoList, // 邮箱
        ContactImInfoList, // qq
        ContactDateInfoList, // 生日
        ContactUrlInfoList, // 网址
        ContactAddressInfoList // 地址
      }
      delete Sysuser.Grade
      delete SysUserPracticeinfo.yishizhicheng
      delete SysUserPracticeinfo.hushijibie
      // 文件
      const EmergencyUserInfo = {
        Sysuser,
        SysUserEducationalinfo,
        SysUserPracticeinfo,
        SysAttachFileList,
        Emergencyaddtioninfo
      }
    //   提交前校验
      let flag = true
    //   表单校验（不包括联系信息）
      this.$refs.AddOrEditFormView.$refs.form.forEach(v => {
        v.validate(val => {
          if(!val) {
            flag = false
            return
          }
        })
      })
    //   联系信息表单校验
      this.$refs.contactForm.validate(v => {
        if(!v) {
          flag = false
          return
        }
      })
    //   登录号码只能唯一且不能重复
      let count = 0
      Object.keys(this.ContactInfoForm).forEach((key, i) => {
        if(this.ContactInfoForm[key] === '登录号码') {
          count ++
        }
      })
      if(count !==1) {
        flag = false
        this.$notify({
          message: '登录号码必填， 且只能添加一个',
          duration: 2000,
          type: 'warning'
        })
        return
      } else {
        //   登录号码后台校验
          let index, phone
          Object.keys(this.ContactInfoForm).forEach(key => {
            if(this.ContactInfoForm[key] === '登录号码') {
              index = key.split('_')[1]
              phone = this.ContactInfoForm['ContactPhoneInfoList_' + index]
            }
          })
          const params = {
            code: '',
            telephone: phone,
            id: this.currentSelectedRow ? this.currentSelectedRow.ID : ''
          }
          const { result, errMsg } = await this.VerifyUserCodeAndPhone(params)
          if(!result) {
            flag = false
            this.$notify({
              message: '登录号码已注册， 请重新填写',
              duration: 2000,
              type: 'success'
            })
            return
          }
      }
    //   基础校验通过才可以提交人员信息
      if(flag) {
        upDateUserInfo({ ...EmergencyUserInfo }).then(res => {
          this.$notify({
            message: '【添加】或【修改】成功',
            duration: 2000,
            type: 'success'
          })
          this.currentView = 'Container'
          this.GetTemplateUserSearchResultCount()
        })
      }
    },
    successSubmit(para) {
      console.log("successSubmitsuccessSubmit", para);
      if (para.ID) {
        let exist = this.allData.find((s) => s.Type == 1 && s.ID == para.ID);
        if (exist) {
          exist.Name = para.Name;
          exist.Phone = para.Telephone[0].Phone;
          exist.Remark = para.Remarks;
          this.allData = this.allData;
        } else {
          this.allData.push({
            Key: "1_" + para.ID,
            ID: para.ID,
            Name: para.Name,
            Type: 1,
            Phone: para.Telephone[0].Phone,
            Remark: para.Remarks,
            TypeName: "联系人",
          });
          console.log("this.datadatatatat", this.allData);
        }
      }
    },
    delContact() {
      if (this.currentSelectedRow && this.currentSelectedRow.Type == 1) {
        this.$confirm("确定删除该联系人数据？", "请确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            DeleteContactInfoById(this.currentSelectedRow.ID)
              .then((res) => {
                if (!res) {
                  this.$message.error("删除失败，请联系管理员！");
                  return;
                } else {
                  this.allData = this.allData.filter(
                    (s) => s.Key !== this.currentSelectedRow.Key
                  );
                  this.currentSelectedRow = null;
                }
              })
              .catch((err) => {
                console.log("DeleteContactInfoById err");
              });
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "请先点击待删除的【联系人】数据行！",
          type: "warning",
        });
        return;
      }
    },
    getSearchResult(data, strParam) {
      console.log("getSearchResult:", data, strParam);
      // data.forEach((s) => {
      //   s.Key = s.Type + "_" + s.ID;
      // });
      this.allData = this.FilterTableData(data);
      this.currentSelectedRow = null;
    },
    currentChanged(newRow, oldRow) {
      console.log(newRow, oldRow)
      this.currentSelectedRow = newRow;
    },
    searchDialogClosed() {
      //this.$refs.mainDialog.searchDialogClosed();
    },
    formatterTypeStatus(row) {
      let ret = "";
      switch (row.Type) {
        case 0:
          {
            ret = "success";
          }
          break;
        case 1:
          {
            ret = "info";
          }
          break;
      }
      return ret;
    },
    deleteResult(data) {
      if (data) {
        console.log("deleteResult", data);
        data.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, false);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        pull: "clone",
        sort: false,
        //   onEnd({ newIndex, oldIndex }) {
        //     const currRow = _this.allData.splice(oldIndex, 1)[0]
        //     _this.allData.splice(newIndex, 0, currRow)
        //   }
        onStart: function ({ newIndex, oldIndex }) {
          const currRow = _this.allData[oldIndex]; //.splice(oldIndex, 1)[0];
          _this.$store.commit("draggableRow", currRow);
        },
      });
    },
    LuneceSearch(keyWord) {
      //关键字搜索
      // let userPara = {
      //   Keyword: keyWord,
      //   ListPostId: [],
      //   CurrentUserId: this.userId,
      //   ListCompanyDept: {
      //     CompanyId: "",
      //     DepId: "",
      //     CompanyGeneralCode: "",
      //     COmpanyName: "",
      //     DeptName: ""
      //   },
      //   SearchRange:2
      // };

      // let userPara = {
      //   CurrentUserId: this.userId,
      //   Keyword: keyWord,
      //   ListCompanyDept: [],
      //   ListPostId: [],
      //   SearchRange: 2,
      // };
      // this.pageParams.Para = JSON.stringify(userPara);
      // this.GetTemplateUserSearchResultCount(this.pageParams);
      const Para = {
        CurrentUserId: this.userId,
        keyWord,
        ListCompanyDept:[], ListPostId:[],
        SearchRange:0
      }
      this.queryParams.Para = JSON.stringify(Para)
      this.pageParams = {
        Pageindex: 1,
        Pagesize: 10
      }
      this.GetTemplateUserSearchResultCount()
    },
    openSearch(data, type) {
      this.$refs.userSearchDialog.SearchOpen(data, type)
    },

    getAllTask(data) {
      this.pageParams = {
        Pageindex: 1,
        Pagesize: 10
      }
      // 点击树结构模板动态查询
      if (data.TEMPTYPE == 0) {
        this.TEMPTYPE = 0
        //0:搜索模板
        this.getSearParm(data.CONTENT);
        let content = JSON.parse(data.CONTENT);

        let queryTitle = content.queryTitle ? content.queryTitle : content;
        // let queryTitle = {"CurrentUserId":"28","Keyword":"陈","ListCompanyDept":[],"ListPostId":[],"SearchRange":0}
        
        this.$store.state.template.searchCondition = queryTitle;
        this.queryParams.Para = JSON.stringify(queryTitle);
        this.GetTemplateUserSearchResultCount();
      } else if (data.TEMPTYPE == 1) {
        this.TEMPTYPE = 1
        this.TEMPID = data.ID
        // 1:结果集
        this.showSercParams = {};
        this.GetTemplateUserSearchResultByTemplateID(data.ID, this.userId);
      }
      this.currentSelectedRow = null;
    },
    FilterTableData(data) {
      const dataInfo = data.map(v => {
        v.SysUserName = v.Sysuser.SysUserName //姓名
        v.SysUserCode = v.Sysuser.SysUserCode // 工号
        v.SysUserSex = v.Sysuser.SysUserSex === 1 ? '男' : '女'
        v.IsLogin = v.Sysuser.IsLogin
        // v.IsLoginName = v.Sysuser.IsLogin === 0 ? '联系人' : '人员' // 类型
        // v.IsLoginState = v.Sysuser.IsLogin === 0 ? '不可登录' : '可登录' // 登录状态
        // v.IsLock = v.Sysuser.IsLock === 0 ? '否' : '是' // 是否锁定
        v.IsLock = v.Sysuser.IsLock
        v.ID = v.Sysuser.SysId
        v.DutyName = v.Sysuser.DutyName // 职务
        v.SysUserState = v.Sysuser.SysUserState // 人员状态
        v.Grade = v.Emergencyaddtioninfo.Grade // 等级
        v.Position = v.Sysuser.Position // 职位
        v.JobTitle = v.SysUserPracticeinfo && v.SysUserPracticeinfo.JobTitle // 职称
        // v.Telphone = v.Sysuser.Telphone // 电话
        v.Age = v.Sysuser.Age // 年龄
        v.EmergencyCompanyofDeptList = v.Emergencyaddtioninfo.EmergencyCompanyofDeptList && v.Emergencyaddtioninfo.EmergencyCompanyofDeptList.map(val => {
          return val.CompanyName + val.DeptName
        }).join(',') // 组织
        v.EmergencyPostInfoList = v.Emergencyaddtioninfo.EmergencyPostInfoList && v.Emergencyaddtioninfo.EmergencyPostInfoList.map(val => {
          return val.PostName
        }).join(',') // 岗位
        v.Email = v.Emergencyaddtioninfo.ContactEmailInfoList && v.Emergencyaddtioninfo.ContactEmailInfoList.length && v.Emergencyaddtioninfo.ContactEmailInfoList[0].Email
        if(v.Emergencyaddtioninfo.ContactPhoneInfoList) {
          v.Emergencyaddtioninfo.ContactPhoneInfoList.forEach(val => {
            if(val.PhoneType === '对外显示号码') v.Telphone = val.Phone
          })
        }
        return v
      })
      return dataInfo
    },
    GetTemplateUserSearchResultCount() {
      this.loading = true;
      // this.dataIniting = true;
      this.allData = []
      // GetTemplateUserSearchResultCount(userPara).then((response) => {
      //   console.log("GetTemplateUserSearchResultCount:", response);
      //   let ResultData = response.ResultData;
      //   ResultData.forEach((s) => {
      //     s.Key = s.Type + "_" + s.ID;
      //   });

      //   response.ResultCount >= 0
      //     ? (this.paginationVisible = true)
      //     : (this.paginationVisible = false);
      //   this.allData = ResultData;
      //   this.total = response.ResultCount;
      //   this.loading = false;
      // });
      GetNewEmergencyUserSearchResultCount({...this.pageParams, ...this.queryParams}).then((response) => {
        let ResultData = this.FilterTableData(response.ResultData)
        // ResultData.forEach((s) => {
        //   s.Key = s.Type + "_" + s.ID;
        // });

        response.ResultCount >= 0
          ? (this.paginationVisible = true)
          : (this.paginationVisible = false)
        this.allData = ResultData
        this.total = response.ResultCount
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    GetTemplateUserSearchResultByTemplateID(TemplateId, OpUserId) {
      this.loading = true;
      this.allData = []
     
      GetNewEmergencyUserSearchResultCountByTemplateId({ TemplateId, OpUserId, ...this.pageParams }).then(
        (response) => {
          const data = response.ResultData
          // data.forEach((s) => {
          //   s.Key = s.Type + "_" + s.ID;
          // });
          data.length >= 0
            ? (this.paginationVisible = true)
            : (this.paginationVisible = false);
          this.allData = this.FilterTableData(data);
          this.total = response.ResultCount;
          if (response.ResultCount > 0) {
            this.$store.commit("setResult", data); //  右侧结果集赋值
            this.$store.state.resultBase.isResult = true; //判断当前是否点击结果集
          }
        }
      ).finally(() => {
        this.loading = false
      })
    },
    select(selection, row) {
      let index = selection.indexOf(row);
      if (index > -1) {
        this.$store.commit("addResult", {
          row: row,
          filed: this.filedID,
          key: row[this.filedID],
          bol: true,
        });
      } else {
        this.$store.commit("addResult", {
          row: row,
          filed: this.filedID,
          key: row[this.filedID],
          bol: false,
        });
      }
    },
    selectAll(selection) {
      if (selection.length > 0) {
        //全选事件
        selection.forEach((c) => {
          this.$store.commit("addResult", {
            row: c,
            filed: this.filedID,
            key: c[this.filedID],
            bol: true,
          });
        });
      } else {
        this.allData.forEach((c) => {
          this.$store.commit("addResult", {
            row: c,
            filed: this.filedID,
            key: c[this.filedID],
            bol: false,
          });
        });
      }
    },
    rowContextmenu(row, column, event) {
      console.log(row);
      event.preventDefault();
      this.contextmenuRow = row;
      const postition = {
        top: event.clientY,
        left: event.clientX,
      };

      this.$refs.contextmenus.show(postition);
    },
    handelChat() {
      let id = this.contextmenuRow.ID;
      document.getElementById("chat" + id).click();
    },
    DeleteSameContactProp(item, i) {
      let form = deepClone(this.ContactInfoForm)
      this.ContactInfoItem.forEach(v => {
        if(v.prop === item.prop) v.count = v.count - 1
      })
      this.ContactInfoForm = {}
      // 删除掉ContactInfoForm对应的值
      if(item.prop === 'ContactPhoneInfoList') {
        delete form['phoneSelect_' + i]
      }
      delete form[item.prop + '_' + i]
      // 重新排列
      let obj = {}
      for (const key in form) {
        const k = key.split('_')[0]
        if(obj.hasOwnProperty(k)) {
          obj[k].push(form[key])
        }else {
          obj[k] = [form[key]]
        }
      }
      for (const key in obj) {
        for(let i=0; i< obj[key].length; i++) {
          // 重新设置ContactInfoForm
          this.$set(this.ContactInfoForm, key + '_' + i, obj[key][i])
        }
      }
    },
    AddSameContactProp(item) {
      // 登录号码初始化select选择
      if(item.prop === 'ContactPhoneInfoList') {
        this.$set(this.ContactInfoForm, 'phoneSelect_' + item.count, '登录号码')
      }
      this.ContactInfoItem.forEach(v => {
        if(v.prop === item.prop) v.count = v.count + 1
      })
    },
    // 获取字典信息（公务员职称， 医师职称， 护士职称， 学历， 学位）
    async GetDictInfoListByType(Stype) {
      let result = await GetDictInfoListByType({Stype})
      return result
    },
    //获取人员职务的数据
    getUserJobList() {
      const Orgid = getToken().organizationId || "";
      getUserJobList({ Opsate: 0, Orgid, pageindex: 1, pagesize: 10000 }).then(
        res => {
          const items = res.Items.map(item => {
            const obj = {
              value: item.ID,
              label: item.NAME
            }
            return obj
          })
          this.contentConfig[2].formItemList.forEach(v => {
            if(v.prop === 'DutyId') v.list = items
          })
        }
      )
    },
    //上传
    fileSuccess(a, b, c, d) {
      const item  = {
         baseAddress:'http://117.71.55.7:14909',
         FileId: c.id,
         fileName: c.filename,
         CreateUserId: this.userId,
         CreateUserName: this.realName
      }
      this.src = this.matchTypeImg(item)
      console.log('这是头像上传成功后的回调=》', c)
      this.file_1_List = {
        FilePath: '',
        Name: c.filename,
        HasCode: c.hashcode,
        FileType: 1,
        FileId: c.id,
        Url: c.url
      }
    },
    matchTypeImg(item) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = item.fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return require("@/assets/默认头像.png");
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        return `${item.baseAddress}/api/File/Preview?FileId=${item.FileId}&FileName=${item.fileName}&CreateUserId=${item.CreateUserId}&CreateUserName=${item.CreateUserName}`
      }
    },
    fileComplete() {},
    // excel导出
    handleDownload() {
      const header = []
      const propsList = []
      this.tableColumns.forEach(v => {
        header.push(v.label)
        propsList.push(v.prop)
      })
      const data = this.allData.map(v => {
        return propsList.map(j => {
          return v[j]
        })
      })
      this.$export_json_to_excel({
        header,
        data,
        filename: '人员表'
      })
    },
  },
  mounted() {
    this.rowDrop();
    this.GetTemplateUserSearchResultCount()
  },
  activated() {
      console.log('组件被激活了')
    // 组件激活默认是加载Container组件
    this.currentView = 'Container'
    // 组件激活默认加载
    this.GetTemplateUserSearchResultCount()
  },
  computed: {
    ...mapState({
      isCheckbox: (state) => state.task.isCheckbox,
      userId: (state) => state.task.userId,
      realName: (state) => state.task.realName,
    }),
  },
};
</script>
<style lang="less" scoped>
  .item-wrap-title {
    /deep/.uploader-btn {
    //   margin-left: 10px;
    //   width: 28px;
    //   height: 28px;
    //   line-height: 1;
    //   border-radius: 50%;
    //   background: #4495ff;
    //   text-align: center;
    //   color: #fff;
    //   border: none;
    color: #23ad9e;
    background-color: #fff;
    border: 1px solid #23ad9e;
    font-size: 12px;
    border-radius: 4px;
    padding:5px 8px;
    margin-left:8px;
    }
  }
  /deep/ .uploader-btn {
    padding: 0;
    border: none;
    .user-picture-wrap{
      border-radius: 50%;
    }
  }
  /deep/ .item-wrap-pic{
    .uploader {
      margin-bottom: 60px;
      margin-top: 30px;
      text-align: center;
    }
  }
  .user-picture-wrap {
    width: 180px;
    height: 180px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  /deep/.contact-info-item-validate {
    .el-form-item__label {
      position: relative;
    }
  }
  /deep/.contact-info-item-validate.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
  .contact-el-row {
    width: 100%;
  }
  .boxcard {
    border: 0;
    /deep/ .el-card__body {
      padding: 0 10px;
    }
  }
  .user-btn-groups {
    /deep/.el-button + .el-button {
      margin-left: 10px;
    }
  }
  .contact-info-item {
    .contact-info-item-label-wrap {
      display: flex;
      align-items: center;
    }
    .contact-info-item-select-wrap {
      /deep/.el-input__inner {
        border: none;
      }
    }
    /deep/ .el-form-item__content {
      display: flex;
    }
    /deep/.el-button {
      margin-left: 10px;
    }
    .contact-info-item-btns {
      display: inline-block;
      width: 100px;
    }
    .contact-info-item-icon {
      font-size: 22px;
    }
  }
</style>